import {
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material';
import DownArrow from '@mui/icons-material/ExpandMoreRounded';
import InputWrapper from '../InputWrapper';
import { important, isNil, sxToObject } from '../../../../utils/global/helper';
import { getInputBorderStyle } from '../../../../helpers/styles';

interface Props {
  id: string;
  label?: string;
  isLabelMultiline?: boolean;
  placeholder?: string;
  disabled?: boolean;
  options: {
    value: string | boolean;
    label: string;
    hidden?: boolean;
  }[];
  tooltip?: string;
  autoWidth?: boolean;
  value: string | undefined;
  onChange: (value: string) => void;
  onBlur?: () => void;
  selectSx?: SxProps<Theme>;
  isError?: boolean;
  required?: boolean;
}

function SingleSelectControlled({
  id,
  label,
  placeholder,
  isLabelMultiline,
  disabled,
  options,
  tooltip,
  autoWidth = true,
  value,
  onChange,
  onBlur,
  selectSx,
  isError,
  required,
}: Props) {
  const theme = useTheme();
  return (
    <InputWrapper
      label={label}
      name={id.toString()}
      tooltip={tooltip}
      isLabelMultiline={isLabelMultiline}
      required={required}>
      <Select
        IconComponent={DownArrow}
        sx={{
          height: important('44px'),
          fontSize: '0.875rem',
          '& .MuiOutlinedInput-notchedOutline': getInputBorderStyle({
            theme,
            isError,
          }),
          bgcolor: theme.palette.background.default,
          ...sxToObject(selectSx, theme),
        }}
        defaultValue={isNil(value) ? '' : value}
        value={isNil(value) ? '' : value}
        onChange={async (event: SelectChangeEvent) => {
          onChange(event.target.value as string);
        }}
        input={<OutlinedInput />}
        displayEmpty
        autoWidth={autoWidth}
        label={placeholder}
        disabled={disabled}
        onBlur={onBlur}>
        {placeholder && (
          <MenuItem
            sx={{
              fontSize: '0.875rem',
            }}
            disabled
            value="">
            <em>{placeholder}</em>
          </MenuItem>
        )}
        {options.map(option => (
          <MenuItem
            sx={{
              fontSize: '0.875rem',
              display: option.hidden ? 'none' : 'block',
            }}
            value={option.value as string}
            key={option.value.toString()}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </InputWrapper>
  );
}

export default SingleSelectControlled;
